import { render, staticRenderFns } from "./ServingSuggestions.vue?vue&type=template&id=0feb9791&"
import script from "./ServingSuggestions.vue?vue&type=script&lang=js&"
export * from "./ServingSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports